import { useState } from "react";
import PrimaryButton from "../../common/components/PrimaryButton";
import Loading from "../../common/components/Loading";
import { Link } from "react-router-dom";

function ProfileInfo({ user, userUpdate, isLoading }) {
  const [userName, setUserName] = useState(user?.userName);

  const { email } = user;

  return (
    <div className="grid md:grid-cols-2 gap-20 w-fit pt-8">
      <div>
        <div className=" text-gray-500">
          <div>Full name</div>
        </div>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            const formData = new FormData();
            formData.append("message", JSON.stringify({ userName }));

            userUpdate(formData);
          }}
          className="flex space-x-4"
        >
          <input
            type="text"
            className={`px-2 py-2 rounded-md border-2 border-gray-300 outline-none focus:ring-2 ring-purple-500 transition ease-in-out delay-150 w-full`}
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
          />

          <PrimaryButton
            btnCls="!w-fit text-sm flex items-center"
            buttonProps={{ type: "submit", disabled: !userName || isLoading }}
          >
            {isLoading ? <Loading /> : ""}
            Update
          </PrimaryButton>
        </form>
      </div>
      <div>
        <div className=" text-gray-500">Email</div>
        <div className="mb-2">{email}</div>
        <Link to="/reset-password" className="back_link underline">
          Reset password
        </Link>
      </div>
    </div>
  );
}

export default ProfileInfo;
